var industryNew = {
    signupStatus: "",

    //数字动画
    animationNumProperty : [
        {
            isplaying: false,  //是否正在动画
            isShowOver: false, //是否执行过动画，如果执行过就不需要再次执行了，控制执行一次
        },
        {
            isplaying: false,  //是否正在动画
            isShowOver: false, //是否执行过动画，如果执行过就不需要再次执行了，控制执行一次
        },
        {
            isplaying: false,  //是否正在动画
            isShowOver: false, //是否执行过动画，如果执行过就不需要再次执行了，控制执行一次
        }
    ],

    searchTagList: [],

    //swiper 初始化
    initSwiper: function(){
        var self = this;

        //相关设备推荐swiper
        this.initRecommendProductSwiper();

        //轮播
        new Swiper ('.swiper-container-industry-new', {
            // initialSlide :1,
            direction: 'horizontal', // 垂直切换选项
            loop: ($("#bannerNumber").val() > 1), // 循环模式选项
            observer:true,//修改swiper自己或子元素时，自动初始化swiper
            observeParents:true,//修改swiper的父元素时，自动初始化swiper

            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },

            // 如果需要分页器
            pagination: {
                el: '.swiper-pagination-cycbanner',
            },
        });
        var bannerLen = $(".banner-swiper-telecom .swiper-wrapper").find(".swiper-slide").length;
        console.log(bannerLen);
        if(bannerLen>1){
            var bannerswipertelecom = new Swiper ('.banner-swiper-telecom', {
                // initialSlide :1,
                // direction: 'horizontal', // 垂直切换选项
                loop: true, // 循环模式选项
                observer:true,//修改swiper自己或子元素时，自动初始化swiper
                observeParents:true,//修改swiper的父元素时，自动初始化swiper
    
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
    
                // 如果需要分页器
                pagination: {
                    el: '.banner-swiper-telecom .swiper-pagination',
                },
            });
        }

        // this.animationNum = -1; //控制动画执行一次

        if (window.cateData.pageIndustryType === 'healthcare' || window.cateData.pageIndustryType === 'education' ) {
            //医疗行业 数字动画swiper
            new Swiper('.swiper-container-healthcase-data',{
                pagination: {
                    el: '.swiper-pagination-healthcase-data'
                },
                on: {
                    slideChangeTransitionEnd:function () {
                        var index = this.activeIndex;
                        //console.log(self.animationNum,index);
                        //控制动画执行一次
                        // if (self.animationNum < index){
                        //     self.animationNum = index;
                        self.numberAnimation(index);
                        // }
                    }
                }
            })
        }
    },

    //相关推荐swiper
    initRecommendProductSwiper: function(){

        if (window.cateData.pageIndustryType === 'education'){
            //教育行业
            var self = this;

            function productswiper(activeIndex){
                if (self.studentProductSwiper){
                    self.studentProductSwiper.destroy();
                }
                self.studentProductSwiper = new Swiper('.swiper-container-recommend-'+activeIndex,{
                    roundLengths: true,//防止模糊
                    speed: 300,//动画时间
                    slidesPerView: 2,//
                    // slidesPerGroup: 2,
                    spaceBetween: 20,
                    observer:true,//修改swiper自己或子元素时，自动初始化swiper
                    observeParents:true,//修改swiper的父元素时，自动初始化swiper
                    pagination: {
                        el: '.swiper-pagination-recommend-'+activeIndex,
                    }
                })
            }

            productswiper(1);

            $(".tab-content-recommend li").on("click",function (event) {
                $(".tab-content-recommend li").removeClass("seld");
                $(this).addClass('seld');
                //点击的位置
                var activeIndex = $(this).index();
                activeIndex+=1;
                $(".recommend-product-box").addClass('hide')
                $("#recommend-product-box-"+activeIndex).removeClass('hide');

                productswiper(activeIndex);
            })

        }else{
            new Swiper('.swiper-container-recommend-1',{
                roundLengths: true,//防止模糊
                speed: 300,//动画时间
                slidesPerView: 2,//
                // slidesPerGroup: 2,
                spaceBetween: 20,
                pagination: {
                    el: '.swiper-pagination-recommend-1',
                }
            })
        }
    },

    //数字动画
    numberAnimation: function(index){
        var pro = industryNew.animationNumProperty[index];
        var nums = [60, 70, 1];
        if (window.cateData.pageIndustryType === 'education'){
            nums = [14,17,1]
        }
        if (pro.isplaying || pro.isShowOver){
            //如果正在动画则不执行以下操作
            return;
        }
        if (nums[index] == 1){
            pro.isShowOver = true;
            $(".healthcare-big-data .item-num").eq(index).text(1);
            return;
        }
        jQuery({ Counter: 0 }).animate({ Counter: nums[index] }, {
            duration: 30*nums[index] > 2000 ? 2000 : 30*nums[index] ,
            easing: 'swing',
            step: function () {
                var n = Math.round(this.Counter);
                if (n == nums[index]){
                    //动画执行完毕设置为false
                    pro.isplaying = false;
                    pro.isShowOver = true;
                }
                if (window.cateData.pageIndustryType === 'healthcare' && n.toString().length > 1 && index == 0){
                    // n = n.toString();
                    var firstnum = Math.round(n / 10);
                    var lastnum = n % 10;
                    $(".healthcare-big-data .item-num").eq(index).text(firstnum + "," + lastnum);
                }else{
                    $(".healthcare-big-data .item-num").eq(index).text(n);
                }
            }
        });
    },

    //滚动监听
    scrollEvent: function(){
        var beforeScrollTop = 0;
        var animatePlaying = false;
        var self = this;
        $(window).scroll(function () {
            //tab收起展开动画
            var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
            if (scrollTop < 40) {
                $('.industry-tab').slideDown();
            } else {
                $('.industry-tab').slideUp();
            }
            if (window.cateData.pageIndustryType === 'healthcare' || window.cateData.pageIndustryType === 'education' ) {
                //健康行业大数据动画
                var bigDataSwiper = document.getElementsByClassName("swiper-container-healthcase-data")[0];
                if (!animatePlaying && beforeScrollTop < document.scrollingElement.scrollTop && document.scrollingElement.scrollTop + document.body.clientHeight - $(".swiper-container-healthcase-data").height() * 2 > $(".swiper-container-healthcase-data").offset().top) {
                    //动画没有开始 & 向上滚动 & 动画数字view显示出来
                    animatePlaying = true;
                    self.numberAnimation(0);
                }
                beforeScrollTop = document.scrollingElement.scrollTop;
            }
        });
    },

    /*
        分页控制
        totalPage: 2,  //总页数
        currentPage: 1, //当前页 初始化1
    * */
    pageProperty:{},

    /*
    * 分页注册事件 点击展开、收起事件
    * id 列表页父标签id
    * */
    registePageEvent: function(id){
        var self = this;
        //datacount 列表页数据量，根据这个数据量/2 计算页数
        var datacount = $("#"+id+" .content-list").length;
        //如果数据量大于3即大于一页 才需要展开功能
        if (datacount > 3){
            function showMoreEvent(controlId) {
                $("#"+controlId+" .show-more").eq($("#"+controlId+" .show-more").length - 1).on("click",function () {
                    self.pageProperty[controlId].currentPage += 1;
                    self._openPage(controlId);
                })
            };
            showMoreEvent(id);
            //每个模块id为key 记录当前页数和总页数
            this.pageProperty[id] = {
                totalPage: Math.ceil(datacount / 3),  //总页数
                currentPage: 1, //当前页 初始化1
            }
            this.initPage(id);
        }
    },

    //初始化
    initPage: function(id){
        $("#" + id + " .content-list").addClass('hide').removeClass('ani-droplist-down');
        this._openPage(id);
    },

    initModel: function() {
        new Vue({
            el: '.page-industry-new',
            data: {
                programDataList: [], // 智慧圆桌会议
                isSearchData: false,
                programSwiper: null,
                isLoading: false,
                searchProgramTagList: [],

                caseSwiper: null, // 案例智库swiper
                caseDataList: [], // 客户案例
                isLoadingCase: false,
                isSearchCaseData: false,
                searchCaseTagList: [],
            },
            methods: {
                /* 金融行业筛选标签 */
                searchByTags: function() {
                    var _this = this;
                    var searchTags = _this.searchTags('program');
                    if (searchTags == _this.searchProgramTagList) {
                        return;
                    }
                    _this.isLoading = true;
                    _this.isSearchData = true;
                    _this.searchProgramTagList = searchTags;
                    var param = {
                        tags: searchTags,
                        categroy: window.cateData.pageIndustryType
                    };
                    postJson(window.cateData.api.searchProgramData, param, function (res) {
                        if (res.Code == '200' && res.data) {
                            _this.programDataList = res.data;
                            if (_this.programDataList.length > 1) {
                                setTimeout(function () {
                                    _this.initProgramSwiper();
                                }, 200);
                            }
                        }
                        _this.isLoading = false;
                    });
                },

                searchCaseByTags: function() {
                    var _this = this;
                    var searchTags = _this.searchTags('case');
                    if (searchTags == _this.searchCaseTagList) {
                        return;
                    }
                    _this.isLoadingCase = true;
                    _this.isSearchCaseData = true;
                    _this.searchCaseTagList = searchTags;
                    var param = {
                        type: '1',
                        tags: searchTags,
                        categroy: window.cateData.pageIndustryType
                    };
                    postJson(window.cateData.api.searchProgramData, param, function (res) {
                        if (res.Code == '200' && res.data) {
                            _this.caseDataList = res.data;
                            if (_this.caseDataList.length > 3) {
                                setTimeout(function () {
                                    _this.initCaseSwiper();
                                }, 200);
                            }
                        }
                        _this.isLoadingCase = false;
                    });
                },

                searchTags: function(type) {
                    var sTagArr = [], searchTags = '';
                    $('.m-view-header .selected-tag').each(function (id, item) {
                        var tagId = $(item).attr('data-tag-id');
                        var parentModule = $(item).attr('data-parent-module');
                        if (tagId && parentModule == type) {
                            sTagArr.push(tagId);
                        }
                    });

                    if (sTagArr.length > 0) {
                        searchTags = sTagArr.join('-');
                    }

                    console.log(searchTags);
                    return searchTags;
                },

                playVideo: function(item) {
                    filelist.video(item.fileUrl, item.originTitle, item.isNeedLogin, item.id, item.url);
                },
                previewFile: function (item) {
                    filelist.preview(item.fileUrl, item.originTitle, item.isNeedLogin, item.id, item.fileId, item.fileName);
                },
                /* 按钮绑定事件 */
                bindEvents: function () {
                    var _this = this;
                    $('.filter-item > .item-selected-box').click(function () {
                        stopEvent();
                        $('.filter-item > .item-tag-list').hide();
                        $(this).siblings('.item-tag-list').show();
                    });

                    $('.filter-item .tag-item').click(function () {
                        var tagId = $(this).attr('data-tag-id');
                        var tagName = $(this).text();
                        var parentModule = $(this).attr('data-parent-module');

                        $(this).parent().find('.tag-item').removeClass('selected-tag');
                        $(this).addClass('selected-tag');

                        $(this).parent().parent().find('.cur-tag-item').text(tagName).attr('data-tag-id', tagId);

                        if (parentModule == 'case') {
                            _this.searchCaseByTags();
                        } else {
                            _this.searchByTags();
                        }
                    });

                    $(document).click(function () {
                        $('.filter-item > .item-tag-list').hide();
                    });
                },
                initProgramSwiper: function () {
                    if (this.programSwiper) {
                        this.programSwiper.destroy();
                    }
                    this.programSwiper = new Swiper('.j-program-swiper', {
                        autoHeight: true,
                        observable: true,
                        observeParents: true,
                        pagination: {
                            el: '.j-program-swiper .content-list-pager'
                        },
                    });
                },
                initCaseSwiper: function() {
                    if (this.caseSwiper) {
                        this.caseSwiper.destroy();
                    }
                    this.caseSwiper = new Swiper('.m-case-list', {
                        autoHeight: true,
                        observable: true,
                        observeParents: true,
                        pagination: {
                            el: '.m-case-list .content-list-pager'
                        },
                    });
                }
            },
            mounted: function () {
                this.initProgramSwiper();
                this.initCaseSwiper();
                this.bindEvents();
            }
        });
    },

    //id 列表页父标签id
    _openPage: function(id){

        if (this.pageProperty[id].currentPage == this.pageProperty[id].totalPage){
            //已经全部展示 提示改为“收起” 箭头向上
            $("#"+id+" .show-more").html('收起<span class="icon iconfont icon-pre_up"></span>')
        }else if(this.pageProperty[id].currentPage > this.pageProperty[id].totalPage){
            //当前页数大于总页数时则为收起事件，将currentPage置为1，重新初始化
            $("#"+id+" .show-more").html('展开<span class="icon iconfont icon-pre_down"></span>')
            this.pageProperty[id].currentPage = 1;
            $("html,body").animate({scrollTop:$("#"+id).offset().top + "px"}, 500);
            this.initPage(id);
            return;
        }

        var listclass = "#" + id + " .content-list";
        $.each($(listclass),function (index) {
            if (index+1 <= this.pageProperty[id].currentPage * 3) {
                $(listclass).eq(index).removeClass("hide").addClass('ani-droplist-down');
            }
        }.bind(this))
    },
    clickDownLoad: function(url,title,islogin,id,fileid,filename,fileurl){
        // if(_this.signupStatus == "allow"){
        //     window.location.href = "https://smarket.dellemc-solution.com/f/182a856d4572c5432de0d95d62f6b3c3/view/customForm.html?customFormId=4830&instanceId=&linkId=9671&configId=45743#";
        // }else{
        //     window.location.href = url;
        // }
    },
   
    init: function () {
        this.initSwiper();
        this.scrollEvent();
        
        if (window.cateData.pageIndustryType === 'healthcare' || window.cateData.pageIndustryType === 'education') {
            //医疗行业要分页 每页2条数据
            //content-list-1 为模块id，根据id去操作dom
            this.registePageEvent("content-list-1");
            this.registePageEvent("content-list-2");
            this.registePageEvent("content-list-3");
        }

        if (window.cateData.pageIndustryType === 'finance') {
            this.initModel();
        }

        $(".g-tab-content .tabButton").on("click",function(){
            $(".g-tab-content .tabButton").removeClass("on")
            $(this).addClass("on");
            var _tab_class = $(this).attr("data-type");
            $(".tabcont").removeClass("on");
            $(".tabcont." + _tab_class).addClass("on");
        })
    }
}
